import { render, staticRenderFns } from "./selectStatement.vue?vue&type=template&id=b424e214&scoped=true"
import script from "./selectStatement.vue?vue&type=script&lang=js"
export * from "./selectStatement.vue?vue&type=script&lang=js"
import style0 from "./selectStatement.vue?vue&type=style&index=0&id=b424e214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b424e214",
  null
  
)

export default component.exports